import ApolloClientService from './apolloclient.service'
import { constants } from '../constants'
import moment from 'moment'
import _ from 'lodash'

const service = new ApolloClientService()

export default class Feedback {
  getFeedbackForms = (customerid) => {
    return new Promise((resolve, reject) => {
      service
        .getAllFeedbackForms({ customerid })
        .then((data) => {
          if (data.status == constants.MESSAGE.SUCCESS) {
            resolve(data)
          } else {
            data.error = true
            data.message = data.status
            reject(data)
          }
        })
        .catch((err) => {
          reject(err)
          console.log(err)
        })
    })
  }

  getPatientFeedSchedule = (patientid) => {
    return new Promise((resolve, reject) => {
      service
        .getPatientFeedSchedule(patientid)
        .then((data) => {
          if (data.status == constants.MESSAGE.SUCCESS) {
            resolve(data)
          } else {
            data.error = true
            data.message = data.status
            reject(data)
          }
        })
        .catch((err) => {
          reject(err)
          console.log(err)
        })
    })
  }

  editFeedSchedule = (input) => {
    return new Promise((resolve, reject) => {
      service
        .editFeedSchedule({
          ...input,
          feedback: this.getFormatedForms(input.feedback),
        })
        .then((data) => {
          if (data.status == constants.MESSAGE.SUCCESS) {
            resolve(data)
          } else {
            data.error = true
            data.message = data.status
            reject(data)
          }
        })
        .catch((err) => {
          reject(err)
        })
    })
  }

  getFormatedForms = (forms) => {
    const d = forms.map((e) => {
      delete e.__typename
      delete e._id
      if (!e.schedule && e.weekdays) {
        e.schedule = e.weekdays.map(
          (i) => _.find(constants.WEEKDAYS, { name: i })?.index
        )
      }
      if (!e.scheduletype) e.scheduletype = 'weekly'
      delete e.index
      delete e.shortname
      delete e.image
      delete e.editnew
      delete e.questions
      return e
    })

    return d
  }

  getDeafultFeedSchedule = (input) => {
    return new Promise((resolve, reject) => {
      service
        .getDeafultFeedSchedule(input)
        .then((data) => {
          if (data.status == constants.MESSAGE.SUCCESS) {
            resolve(data)
          } else {
            data.error = true
            data.message = data.status
            reject(data)
          }
        })
        .catch((err) => {
          reject(err)
          console.log(err)
        })
    })
  }

  getFormGraphData = (customerid, date) => {
    return new Promise((resolve, reject) => {
      service
        .getFormGraphData(customerid, date)
        .then((data) => {
          if (data.status == constants.MESSAGE.SUCCESS) {
            resolve(data)
          } else {
            data.error = true
            resolve(data)
          }
        })
        .catch((err) => {
          reject(err)
          console.log(err)
        })
    })
  }

  getSurveyDetail = (patientid) => {
    return new Promise((resolve, reject) => {
      service
        .getSurveyDetail(patientid)
        .then((data) => {
          if (data.status == constants.MESSAGE.SUCCESS) {
            resolve(data)
          } else {
            data.error = true
            resolve(data)
          }
        })
        .catch((err) => {
          reject(err)
          console.log(err)
        })
    })
  }
}
